import React from 'react'
import { _formatPrice } from '../../Utils/tools'
import { setUserProperties } from '../../Utils/utils'
import './BannerConvenioPro.css'

/* img */
import BannerConvenioDesk from '../../assets/img/banner-convenio-desk.svg'
import BannerConvenioTablet from '../../assets/img/banner-convenio-tablet.svg'
import BannerConvenioMobile from '../../assets/img/banner-convenio-mobile.svg'

function BannerConvenioPro(props) {

  const saveUserProperty = () => {
    const userProperty = {
      'Saving Generated': props.patientSavings
        ? props.patientSavings
        : 0
    }
    setUserProperties(userProperty)
  }

  return (
    <div className="content-banner-convenio" onClick={ saveUserProperty }>
      <picture>
        <source media="(max-width: 470px)" srcSet={BannerConvenioMobile} />
        <source media="(max-width: 991px)" srcSet={BannerConvenioTablet} />
        <source media="(min-width: 992px)" srcSet={BannerConvenioDesk} />
        <img
          src={BannerConvenioDesk}
          alt="banner"
          className="banner-convenio-pro w-100"
        />
      </picture>
      <div className="content-text-convenio">
        <div className="content-text-convenio-header">
          <h3 className="m-0 txt-1--bold-li text-header">Ahorro total:</h3>
          { props.patientSavings
            ? <h4 className="m-0 txt-1--bold-li text-header">{_formatPrice(props.patientSavings)}</h4>
            : <h4 className="m-0 txt-1--bold-li text-header">$0</h4>
          }
        </div>
        <div className="content-text-convenio-body">
          <p className="txt-4--regular-db text-body pr-3">
            *Ahorro total de tus pacientes gracias a los{' '}
            <span className="txt-4--bold-db text-body">Convenio Yapp</span> que
            has compartido.
          </p>
        </div>
      </div>
    </div>
  )
}

export default BannerConvenioPro
